import { render, staticRenderFns } from "./cetificate-card.vue?vue&type=template&id=99e29354"
import script from "./cetificate-card.vue?vue&type=script&lang=ts"
export * from "./cetificate-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports